const NoActivityData = (): JSX.Element => {
    return (
        <div className="no-activity-data">

            <p className="no-activity-text text-base font-medium">거래 기록이 없습니다.</p>
        </div>
    );
};

export default NoActivityData;